// extracted by mini-css-extract-plugin
var _1 = "lXWU7";
export { _1 as "base" }
